export default "<youtube-player>\r\n  \r\n\r\n</youtube-player>\r\n";